import React from 'react';
import { motion } from 'framer-motion';
import { Home, Signpost, LineChart, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './Card';
const services = [{
  title: 'Buying',
  icon: Home,
  description: 'Find your dream home with personalized search, expert negotiation, and hands-on guidance from start to close.'
}, {
  title: 'Selling',
  icon: Signpost,
  description: 'Strategic pricing, professional marketing, and maximum exposure to get your property sold for top dollar.'
}, {
  title: 'Investing',
  icon: LineChart,
  description: 'Data-driven investment guidance to help you build wealth through smart real estate moves.'
}];
export function Services() {
  return <section id="services" className="py-20 md:py-32 bg-warm-gray" data-id="element-144">
      <div className="container mx-auto px-6" data-id="element-145">
        <div className="text-center mb-16" data-id="element-146">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="block text-gold font-heading text-sm uppercase tracking-widest font-semibold mb-4" data-id="element-147">
            What We Do
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="font-heading text-3xl md:text-4xl lg:text-5xl text-charcoal uppercase tracking-wide" data-id="element-148">
            Full-Service Real Estate
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-149">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} data-id="element-150">
              <Card className="h-full bg-white border-none rounded-none shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group" data-id="element-151">
                <CardContent className="p-10 flex flex-col h-full" data-id="element-152">
                  <div className="h-16 w-16 bg-warm-gray rounded-full flex items-center justify-center mb-8 group-hover:bg-gold group-hover:text-white transition-colors duration-300 text-gold" data-id="element-153">
                    <service.icon className="h-8 w-8" data-id="element-154" />
                  </div>
                  <h3 className="font-heading text-xl uppercase tracking-wider text-charcoal mb-4" data-id="element-155">
                    {service.title}
                  </h3>
                  <p className="font-body text-charcoal/70 leading-relaxed mb-8 flex-grow" data-id="element-156">
                    {service.description}
                  </p>
                  <a href="#contact" className="inline-flex items-center gap-2 text-charcoal font-heading uppercase tracking-wider text-xs font-semibold hover:text-gold transition-colors mt-auto" data-id="element-157">
                    Learn More <ArrowRight className="h-4 w-4" data-id="element-158" />
                  </a>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}